import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LayoutUtilsService} from '../../../../core/_base/crud';
import {SelectionModel} from '@angular/cdk/collections';
import {ProfileModel} from '../../../models/profile.model';
import {ProfileService} from '../../../../provider/profile.service';
import {MenuAsideService} from '../../../../core/_base/layout';
import {Router} from '@angular/router';


@Component({
  selector: 'kt-profiles',
  templateUrl: './profiles.component.html',
  styleUrls: ['./profiles.component.scss']
})
export class ProfilesComponent implements OnInit, OnDestroy {
  datas: ProfileModel[];
  @ViewChild('searchInput', {static: true}) searchInput: ElementRef;
  selection = new SelectionModel<ProfileModel>(true, []);
  loading = true;
  guest_visible = true;

  constructor(private layoutUtilsService: LayoutUtilsService,
              public myService: ProfileService,
              private menuAsideService: MenuAsideService,
              private route: Router) {

    this.menuAsideService.pathname$.next(window.location.pathname);
    this.myService.getProfiles();
    this.guest_visible = JSON.parse(localStorage.getItem('token_form')).guest_visible;
    this.myService.profile_change$.subscribe((datas) => {
        if (datas) {
          this.loading = false;
        }
      }
    );
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
  }

  goProfile(value) {
    this.route.navigateByUrl('/home/profile/' + value);
  }

  getVisible(name: string) {
    let first: string = name.substring(0, 1);
    for (let i = 1; name.length > i; i++) {
      first += '*';
    }
    return first;
  }
}
